// extracted by mini-css-extract-plugin
module.exports = {"tab-pane-content-wrapper":"ActionableDetailsTabPaneHeader_tab-pane-content-wrapper__3KekF"};